import React from 'react';
import { Handle, Position } from 'reactflow';
import { Box } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

export const StartNode = () => {
  return (
    <div 
      className="react-flow__node-default" 
      style={{ 
        minWidth: 100,
        width: 100,
        height: 50,
      }}
    >
      <div style={{ padding: 10, paddingTop: 13, paddingLeft: 0 }}>
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          gap: 1
        }}>
          <PlayArrowIcon />
          Start
        </Box>
      </div>

      <Handle
        type="source"
        position={Position.Right}
        id="default"
        style={{
          right: 0,
          top: '50%',
          transform: 'translateY(-50%)'
        }}
      />
    </div>
  );
}; 